exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */:host{display:flex;align-items:center;justify-content:center;width:260px;height:260px;line-height:40px;border:#e0e0e0 1px solid;background:#fff}img{max-width:100%;max-height:100%}", ""]);

// exports
